import { FaPlusCircle } from "react-icons/fa";
import { FcPicture } from "react-icons/fc";
import { useState, useEffect } from "react";
import Select, { StylesConfig } from "react-select";
import toast from "react-hot-toast";
import Creatable from "react-select/creatable";
import { createPortal } from "react-dom";
import { HiOutlineFilter } from "react-icons/hi";
import sendRequest from "hooks/useAxios";
import { GrClear } from "react-icons/gr";
import logoGM from "assets/images/sitelogo.svg";
import toastFunction from "utils/toast";
import "./Modal.scss";
import "./Store.scss";
export default function FilterStore({
  setForceUpdate,
  setInformationStore,
  informationStore,
  currentPage,
  setCurrentPage,
}) {
  // useState
  const [inputValue, setInptValue] = useState({
    title: "",
    city: "",
    type: "",
  });

  const [inputValueValid, setInptValueValid] = useState({
    title: true,
    city: true,
    type: true,
  });
  const [city, setCity] = useState([]);
  const [showMessag, setShowMassage] = useState(false);
  const [type, setType] = useState([
    { value: "0", label: "تامین کننده اصلی" },
    { value: "1", label: "تامین کننده عادی" },
  ]);
  const [user, setUser] = useState([]);

  // functions
  const ClearInput = () => {
    setInptValue({
      title: "",
      city: "",
      type: "",
    });
  };
  const selectType = (type) => {
    switch (type) {
      case "0":
        return "0";
      case "1":
        return "1";
        defult: return null;
    }
  };
  const toastCustome = (message) => {
    return toast.custom(
      <div
        className="d-flex  "
        style={{
          backgroundColor: "white",
          borderRadius: "10px",
          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
          padding: "10px",
        }}
      >
        <div>
          <img style={{ width: "40px" }} src={logoGM}></img>
        </div>
        <div style={{ alignSelf: "center", marginRight: "5px" }}>{message}</div>
      </div>
    );
  };
  const showError = (message) => {
    return (
      <div>
        <h4>{message}</h4>
      </div>
    );
  };
  const valid = () => {
    if (
      inputValue.title == "" &&
      inputValue.type == "" &&
      inputValue.city == ""
    ) {
      toastFunction("custom", "حداقل یکی از فیلد هارا پر کنید");
    } else if (inputValue.title || inputValue.type || inputValue.city) {
      sendFiltereModal();
    }
  };
  const sendFiltereModal = () => {
    let fd = new FormData();
    if (inputValue.title) {
      fd.append("title", inputValue.title);
    }
    if (inputValue.city.value) {
      fd.append("cityId", inputValue.city.value);
    }
    // if (inputValue.type.value === "0") {
    //   fd.append("type", "0");
    // } else {
    //   fd.append("type", "1");
    // }
    if (inputValue.type.value) {
      fd.append("type", selectType(inputValue.type.value));
    }
    sendRequest("shopfilter", fd).then(({ data }) => {
      if (data.businesses.length > 0) {
        // toastCustome("جستجو فروشگاه باموفقیت انجام شد");
        //setForceUpdate((prev) => !prev);
        setInformationStore(data.businesses);
        document.querySelector("#FilterStoreModal .btn-close").click();
      } else if (data.businesses.length <= 0) {
        document.querySelector("#FilterStoreModal .btn-close").click();
        setInformationStore([]);
      } else {
        document.querySelector("#FilterStoreModal .btn-close").click();
        toastCustome("مشکلی رخ داده است مجدد امتحان کنید");
      }
    });
  };
  // usEffects and api
  useEffect(() => {
    sendRequest("Find_cities").then(({ data }) => {
      setCity([
        ...data.map((value) => {
          return {
            value: value.id,
            label: value.title,
            // phoneNumber: value.mobile,
          };
          // ...data,
        }),
      ]);
    });
  }, []);

  const modalVar = (
    <div
      class="modal fade"
      id="FilterStoreModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      dir="rtl"
    >
      <div className="modal-dialog ">
        <div className="modal-content StoreModal">
          <div className="modal-header" style={{ justifyContent: "end" }}>
            <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
              جستجو فروشگاه
            </h5>
            <button
              type="button"
              className="btn btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div
            className="modal-body style-container"
            style={{ background: "#f2e2c8" }}
          >
            <div className="edit-user-container">
              <form id="edit-user-form-data" className=" edit-container">
                <div>
                  <div
                    className="edit-user-item mt-2 row w-100"
                    style={{ marginTop: "-35px" }}
                  >
                    <div className="col-12 mt-3 ">
                      <div className="lable-modal">
                        <label htmlFor="title"> عنوان</label>
                      </div>
                      <div className="">
                        <input
                          type="text"
                          id="title"
                          name="title"
                          className="input-modal"
                          value={inputValue.title}
                          onChange={(e) => {
                            // if (!isNaN(e.target.value))
                            setInptValue((prev) => {
                              return { ...prev, title: e.target.value };
                            });
                          }}
                        ></input>
                      </div>
                    </div>

                    <div className="col-12 mt-3 ">
                      <div className="lable-modal">
                        <label htmlFor="city"> نوع فروشگاه</label>
                      </div>
                      <div className="">
                        <Select
                          isClearable
                          styles={{ padding: "10px" }}
                          id="city"
                          className="input-modal"
                          options={type}
                          value={inputValue.type}
                          onChange={(e) => {
                            setInptValue((prev) => {
                              return { ...prev, type: e };
                            });
                          }}
                        />
                      </div>
                    </div>

                    <div className="col-12 mt-3 ">
                      <div className="lable-modal">
                        <label htmlFor="city"> شهر</label>
                      </div>
                      <div className="">
                        <Select
                          isClearable
                          id="city"
                          className="input-modal"
                          options={city}
                          value={inputValue.city}
                          onChange={(e) => {
                            setInptValue((prev) => {
                              return { ...prev, city: e };
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {showMessag && <h1>محصولی یافت نشد</h1>}
                </div>
              </form>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                console.log("inpuvalue:", inputValue);
                // sendFiltereModal();
                setCurrentPage(1);
                valid();
              }}
            >
              <HiOutlineFilter></HiOutlineFilter>
              جستجو
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => {
                ClearInput();
                setForceUpdate((prev) => !prev);
                // setInformationStore([]);
                setShowMassage(false);
              }}
            >
              <HiOutlineFilter></HiOutlineFilter>
              حذف جستجو
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
              onClick={() => {
                ClearInput();
              }}
            >
              بستن
            </button>
          </div>
        </div>
      </div>
    </div>
  );
  return createPortal(modalVar, document.querySelector("#modals"));
}
